module.exports = require("./interopRequireWildcard.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scripts/node_modules/babel-runtime/helpers/interop-require-wildcard.js
// module id = 287
// module chunks = 0